var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInstallment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4C5F7E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 29V23H21V25H29V27H21V29H19ZM11 27V25H17V27H11ZM15 23V21H11V19H15V17H17V23H15ZM19 21V19H29V21H19ZM23 17V11H25V13H29V15H25V17H23ZM11 15V13H21V15H11Z",
    fill: "#004AC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstallment);
export default __webpack_public_path__ + "static/media/ic-installment.13c0ce57b1a93ef0a358fb49f0f82123.svg";
export { ForwardRef as ReactComponent };